import Temporal from "../../../../contents/docs/cdp/sources/_snippets/source-temporal.mdx";
import * as React from 'react';
export default {
  Temporal,
  React
};